// Import API modules first
import { authApi } from './auth.api';
import { sampleRequestsApi } from './sampleRequests.api';
import { brandApi } from './brand.api';
import { projectsApi } from './projects.api';
import { adminApi } from './admin.api';
import { imagesApi } from './images.api';
import { contractsApi } from './contracts.api';
import { countriesApi } from './countries.api';
import { shippingApi } from './shipping.api';
import { cosmeticAnalysisApi } from './cosmetic-analysis.api';
import { agentApi } from './agent.api';
import { connectedServicesApi } from './connected-services.api';
import { mcpOAuthApi } from './mcp-oauth.api';
import { mcpOAuthClientsApi } from './mcp-oauth-clients.api';
import { deletedApi } from './deleted.api';
import { api } from './config';

// API Configuration
export { api, setStoreDispatch, setAuthToken, clearAuth, refreshTokenFn } from './config';
export type { ApiError } from './config';

// API Modules
export { authApi } from './auth.api';
export { sampleRequestsApi } from './sampleRequests.api';
export { brandApi } from './brand.api';
export { projectsApi } from './projects.api';
export { adminApi } from './admin.api';
export { imagesApi } from './images.api';
export { contractsApi } from './contracts.api';
export { countriesApi } from './countries.api';
export { shippingApi } from './shipping.api';
export { cosmeticAnalysisApi } from './cosmetic-analysis.api';
export { agentApi } from './agent.api';
export { connectedServicesApi } from './connected-services.api';
export { mcpOAuthApi } from './mcp-oauth.api';
export { mcpOAuthClientsApi } from './mcp-oauth-clients.api';
export { deletedApi } from './deleted.api';
export type { McpAuthApproveRequest, McpAuthApproveResponse } from './mcp-oauth.api';
export type { McpOAuthClientView, McpOAuthClientCreateRequest, McpOAuthClientCreateResponse, McpOAuthClientRevealResponse } from './mcp-oauth-clients.api';
export type { AgentSession, AgentMessage } from './agent.api';
export type { StoredImage } from './images.api';
export type { ContractCreateRequest, ContractSignRequest, ContractRequestDto, ContractUpdateDto, ContractResponse, SignatureResponse } from './contracts.api';
export type { Country } from './countries.api';
export type { ShippingCarrier, ShippingStatus, ShippingResponse } from './shipping.api';

// Helpers
export { uploadFile, getErrorMessage, createFormData } from './helpers';

// Backward compatibility: apiHelpers object
export const apiHelpers = {
  auth: authApi,
  sampleRequests: sampleRequestsApi,
  brand: brandApi,
  projects: projectsApi,
  admin: adminApi,
  images: imagesApi,
  contracts: contractsApi,
  countries: countriesApi,
  shipping: shippingApi,
  cosmeticAnalysis: cosmeticAnalysisApi,
  agent: agentApi,
  connectedServices: connectedServicesApi,
  mcpOAuth: mcpOAuthApi,
  mcpOAuthClients: mcpOAuthClientsApi,
  deleted: deletedApi,
};

// Default export for convenience
export { api as default } from './config';
